import React, {useEffect, useState} from "react"
import CardsContainer from "./Cards";
import {IPublisherDiscOverview} from "../interfaces/DataPointDtoMainPage.interface"
import {AlertTypes, apiClient, Grid, setAlert, Spinner, Skeleton, MuiIcons} from "@leap4/frontend";
import type {SkeletonProps} from "@mui/material";
import {IDateRangeGState, ILoadingComponents} from "../../../../interfaces/datesGlobalState.interface";
import {RootState} from "../../../../interfaces/root-state.interface";
import {connect, ConnectedProps} from "react-redux";
import ReportHeader from "../../common/ReportHeader/ReportHeader";
import {urlService} from "../../../routing/urlsService";
import {publisherDataPointsBaseUrl} from "../../../../config/generals";
import {setIsLoading} from "../../../../store/actions/dateRange.actions";

const {LocationSearching: LocationSearchingIcon} = MuiIcons;

const mapStateToProps = (state: RootState) => ({
    dates: state.dates,
    selectedOrganization:state.auth.selectedOrganizationId
});

const mapActions = {
    setIsLoading
}


const connector = connect(mapStateToProps, mapActions);

type PropsFromRedux = ConnectedProps<typeof connector>;

export interface IPropsTagsMainPage extends PropsFromRedux {
    dates: IDateRangeGState
    setIsLoading: (isLoading: Partial<ILoadingComponents>) => void
}

const PublisherDataPoints: React.FC<IPropsTagsMainPage> = (props: IPropsTagsMainPage): JSX.Element => {
    const {dates, setIsLoading,selectedOrganization} = props;
    const {startDate, endDate, isLoading} = dates
    const [dataPoints, setDataPoints] = useState<IPublisherDiscOverview[]>([]);

    useEffect(() => {
        (async () => {
                try {
                    setIsLoading({isLoadingGeneral: true});
                    const res = await apiClient.post(`${publisherDataPointsBaseUrl}/`, {startDate, endDate})
                    // const res = {data:tagsDataPointsSampleResponse}
                    setDataPoints(res.data);
                } catch (err) {
                    setAlert({msg: "Couldn't get data...", type: AlertTypes.FAILURE,});
                    setDataPoints([])
                } finally {
                    setIsLoading({isLoadingGeneral: false});
                }
            }
        )()
    }, [startDate, endDate,selectedOrganization])


    const skeletonProps:SkeletonProps = {variant:'rounded',height:'340px',width:'430px',animation:'wave', style:{margin:'10px',borderRadius: "16px"}}

    return (
        <>
            <ReportHeader breadcrumbs={[{text: "Publisher Data Points", link: urlService.publisherDataPoints(true), icon: <LocationSearchingIcon />}]}/>
            <Grid  container justifyContent={"center"} alignItems={"center"} >

                {isLoading.isLoadingGeneral ? new Array(8).fill(5).map((_,idx)=><Skeleton key={idx} {...skeletonProps}/>) :
                    (
                        dataPoints.length === 0
                            ?
                            (<span> There isn't data...</span>)
                            :
                            (<Grid item  style={{margin: "2vh"}}>
                                <CardsContainer dataPoints={dataPoints}/>
                            </Grid>)
                    )
                }
            </Grid>
        </>
    );
}

export default connector(PublisherDataPoints);